
// @flow
import * as React from 'react';

import Link from 'app/common/lib/link';
import IconSettings from 'app/common/icons/IconSettings';
import nope from 'app/common/lib/nope';

import PlainGridIconContainer from './PlainGridIconContainer';
import styles from './Gear.module.scss';;


type Props = {
  settingsLink?: string,
  onClickGear?: (e: SyntheticEvent<HTMLElement>) => void,
  children: any,
  loading?: boolean,
  disabled?: boolean,
}

const Gear = ({
  settingsLink = 'setup',
  onClickGear,
  children,
  loading,
  disabled,
}: Props) => (
  <PlainGridIconContainer
    icon={
      <Link
        to={settingsLink}
        onClick={!loading && !disabled && onClickGear ? onClickGear : nope}
      >
        <IconSettings className={styles.svgIcon} />
      </Link>
    }
  >
    {children}
  </PlainGridIconContainer>
);

export default Gear;
